const _ = require('lodash');

function UrlService() {}

UrlService.prototype.decorate = function () {
    const params = [].slice.call(arguments);
    const url = params.shift(); // remove url
    const data = _.reduce(params, (hash, value) => {
        _.each(Object.keys(value), (key) => {
            if (value.hasOwnProperty(key)) {
                hash[key] = value[key];
            }
        });
        return hash;
    }, {});

    const newUrl = url.replace(/{(\w*)}/g, (matcher, key) => {
        return data.hasOwnProperty(key) ? data[key] : '';
    });

    return newUrl;
};


module.exports = UrlService;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/customer-reviews/url-service.js
 **/